const LightningIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_4832_84508)">
        <rect width="16" height="16" fill="white" fillOpacity="0.01" />
        <g clipPath="url(#clip1_4832_84508)">
          <path
            d="M10.9279 0.003218C11.0395 -0.012992 11.1537 0.00919725 11.2512 0.065718V0.0666946C11.3488 0.123398 11.4248 0.211559 11.466 0.316695C11.5073 0.422027 11.5111 0.538687 11.4777 0.646773L9.67697 6.49834H12.9992C13.0969 6.4983 13.193 6.52771 13.2746 6.58134C13.3561 6.63497 13.4205 6.71151 13.4592 6.80107C13.4977 6.89053 13.5092 6.98931 13.4924 7.08525C13.4755 7.18143 13.4305 7.27103 13.3635 7.34209L5.36349 15.8421C5.28611 15.9243 5.1832 15.9782 5.0715 15.9944C4.9597 16.0107 4.8459 15.9878 4.74826 15.931C4.6506 15.8741 4.5745 15.7862 4.53341 15.681C4.49241 15.5758 4.48841 15.4597 4.52169 15.3519L6.32247 9.49833H2.99923C2.90174 9.49828 2.8063 9.46985 2.72482 9.4163C2.64332 9.36268 2.57892 9.28615 2.54025 9.19658C2.50172 9.10712 2.49021 9.00834 2.50704 8.9124C2.52397 8.81622 2.56896 8.72662 2.63595 8.65556L10.636 0.155562C10.7132 0.0735042 10.8164 0.0195412 10.9279 0.003218Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4832_84508">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_4832_84508">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LightningIcon;
